<div [class]="determineContainerStyle()">
	<mat-icon
		*ngIf="shouldDisplay"
		class="clickable md-48"
		(click)="invokeClickEvent()">
		refresh
	</mat-icon>
</div>
